'use strict';

const toExport = {};

if (!process.env.GCLOUD_PROJECT_ON_BUILD && process.env.GCLOUD_PROJECT) {
  process.env.GCLOUD_PROJECT_ON_BUILD = process.env.GCLOUD_PROJECT;
}

toExport.devConfig = {
  isLocalTest: process.env.VUE_APP_LOCAL_TEST === 'true' || process.env.USE_LOCAL_API === '1',
  isLocalAPI: process.env.USE_LOCAL_API === '1',
  isDebugFirestore: process.env.DEBUG_FIRESTORE === '1',
  isEmulator: process.env.GCLOUD_PROJECT === 'emulator'
};

const links = {
  site: {
    name: 'Site',
    link: 'https://www.volan.app.br/'
  },
  facebook: {
    name: 'Facebook',
    link: 'https://www.facebook.com/volan.app.br'
  },
  instagram: {
    name: 'Instagram',
    link: 'https://www.instagram.com/volan.app.br'
  }
};


const android = {
  linkStore: 'https://play.google.com/store/apps/details?id=br.com.justworks.volan',
  storeCode: '',
  id: 'br.com.justworks.volan',
  uri: 'vnd.volan://',
  name: 'Volan',
  packageName: 'br.com.justworks.volan'
};

const ios = {
  linkStore: 'https://apps.apple.com/br/app/volan/id1550690941',
  storeCode: 'id1550690941',
  id: 'id1550690941',
  uri: 'vnd.volan://',
  name: 'Volan',
  packageName: '',
};

toExport.listConfig = {
  'default': {
    configId: 'developerVolan',
    name: 'volandevjw DEVELOPER',
    maps: {
      key: 'AIzaSyAjSPrpte94NNTEnfqToUNhczN0RsVe1M4'
    },
    title: 'Volan DEV ',
    description: 'Volan!',

    baseUrl: 'https://dev.volan.app.br',
    baseUrlForms: 'https://formsdev.volan.app.br',
    baseKey: 'volanDefault_',
    firebase: {
      apiKey: 'AIzaSyD7LGfB5VoQsJmuI8NXPdWTSoEInb6a0F4',
      authDomain: 'volandevjw.firebaseapp.com',
      databaseURL: 'https://volandevjw-default-rtdb.firebaseio.com',
      projectId: 'volandevjw',
      storageBucket: 'volandevjw.appspot.com',
      messagingSenderId: '383344551084',
      appId: '1:383344551084:web:b466e9d01ff6aa1dffeb09',
      measurementId: 'G-JYWS016PJZ'
    },
    functionsUrl: 'https://southamerica-east1-volandevjw.cloudfunctions.net',
    fbId: '',
    links: links,
    android: android,
    ios: ios,
    themeColor: '#4DBA87',
    msTileColor: '#000000',
    appleMobileWebAppCapable: 'no',
    appleMobileWebAppStatusBarStyle: 'default',
    emailKey: 'admin.volan.app.br',
    region: 'southamerica-east1',
    isDevServer: true,
    isMed: true,
    // #1258: para onde o card do guard de sistema manda o usuário. No volandevjw os targets
    // `sistema` e `volanmed` publicam no MESMO site, então as duas linhas caem no mesmo endereço.
    systemLineUrls: {MED: 'https://dev.volan.app.br', MAIN: 'https://dev.volan.app.br'},
    contaAzul: {
      client_id: '76lfbv63hu6g1akiisncd5ntnp',//dev
      client_secret: 'qmfq7pralb83o76397joj20is62etpp3p5mfijg1v0v6qu5skb9',//dev
    },
    apiUrl: 'https://apidev.volan.app.br',
    apiWsUrl: 'wss://apidev.volan.app.br',
    integrationsUrl: 'https://integrationsdev.volan.app.br'
  },
  'volanjwcg': {
    configId: 'volanjwcg',
    name: 'volan PRODUCTION',
    maps: {
      key: 'AIzaSyAjSPrpte94NNTEnfqToUNhczN0RsVe1M4'
    },
    title: 'Volan',
    description: 'Volan!',

    baseUrl: 'https://sistema.volan.app.br',
    baseUrlForms: 'https://forms.volan.app.br',
    baseKey: 'volan_',
    realtimeDatabaseAdditionals: ['https://volanjwcg-belgium.europe-west1.firebasedatabase.app', 'https://volanjwcg-singapore.asia-southeast1.firebasedatabase.app'],
    firebase: {
      apiKey: 'AIzaSyAKxb1IRByUO_ycdklAOtDQ4FL4epbaoiU',
      authDomain: 'volanjwcg.firebaseapp.com',
      databaseURL: 'https://volanjwcg.firebaseio.com',
      projectId: 'volanjwcg',
      storageBucket: 'volanjwcg.appspot.com',
      messagingSenderId: '326211280257',
      appId: '1:326211280257:web:d463dddfae12f3e5d89c80',
      measurementId: 'G-5DGTSM0KB7',
    },
    functionsUrl: 'https://southamerica-east1-volanjwcg.cloudfunctions.net',
    fbId: '',
    links: links,
    android: android,
    ios: ios,
    themeColor: '#000000',
    msTileColor: '#000000',
    appleMobileWebAppCapable: 'yes',
    appleMobileWebAppStatusBarStyle: 'black',
    emailKey: 'admin.volan.app.br',
    region: 'southamerica-east1',
    isDevServer: false,
    isMed: true,
    // #1258: para onde o card do guard de sistema manda o usuário (targets `volanmed` e `sistema`).
    systemLineUrls: {MED: 'https://med.volan.app.br', MAIN: 'https://sistema.volan.app.br'},
    contaAzul: {
      client_id: '650sf6b9l4qetljlckhnt97cfi',
      client_secret: '1fgjgmv531pb9bdca7vsutfi6a4ugjiu67ct0nq3uudbjrjp1dr6',
    },
    apiUrl: 'https://api.volan.app.br',
    apiWsUrl: 'wss://api.volan.app.br',
    integrationsUrl: 'https://integrations.volan.app.br',
  },
  'volandevjw': {
    configId: 'volandevjw',
    name: 'volandevjw DEVELOPER',
    maps: {
      key: 'AIzaSyAjSPrpte94NNTEnfqToUNhczN0RsVe1M4'
    },
    title: 'volandevjw DEV ',
    description: 'Volan!',

    baseUrl: 'https://dev.volan.app.br',
    baseUrlForms: 'https://formsdev.volan.app.br',
    baseKey: 'volanDev_',
    firebase: {
      apiKey: 'AIzaSyD7LGfB5VoQsJmuI8NXPdWTSoEInb6a0F4',
      authDomain: 'volandevjw.firebaseapp.com',
      databaseURL: 'https://volandevjw-default-rtdb.firebaseio.com',
      projectId: 'volandevjw',
      storageBucket: 'volandevjw.appspot.com',
      messagingSenderId: '383344551084',
      appId: '1:383344551084:web:b466e9d01ff6aa1dffeb09',
      measurementId: 'G-JYWS016PJZ'
    },
    functionsUrl: 'https://southamerica-east1-volandevjw.cloudfunctions.net',
    fbId: '',
    links: links,
    android: android,
    ios: ios,
    themeColor: '#4DBA87',
    msTileColor: '#000000',
    appleMobileWebAppCapable: 'no',
    appleMobileWebAppStatusBarStyle: 'default',
    emailKey: 'admin.volan.app.br',
    region: 'southamerica-east1',
    isDevServer: true,
    isMed: true,
    // #1258: para onde o card do guard de sistema manda o usuário. No volandevjw os targets
    // `sistema` e `volanmed` publicam no MESMO site, então as duas linhas caem no mesmo endereço.
    systemLineUrls: {MED: 'https://dev.volan.app.br', MAIN: 'https://dev.volan.app.br'},
    contaAzul: {
      client_id: '76lfbv63hu6g1akiisncd5ntnp',//dev
      client_secret: 'qmfq7pralb83o76397joj20is62etpp3p5mfijg1v0v6qu5skb9',//dev
    },
    apiUrl: 'https://apidev.volan.app.br',
    apiWsUrl: 'wss://apidev.volan.app.br',
    integrationsUrl: 'https://integrationsdev.volan.app.br'
  },
  'volaninternal': {
    configId: 'volaninternal',
    name: 'volaninternal DEVELOPER',
    maps: {
      key: 'AIzaSyAjSPrpte94NNTEnfqToUNhczN0RsVe1M4'
    },
    title: 'volaninternal DEV ',
    description: 'Volan!',

    baseUrl: 'https://sistema.volan.app.br',
    baseUrlForms: 'https://forms.volan.app.br',
    baseKey: 'volanInternal_',
    firebase: {
      apiKey: 'AIzaSyC24qNiBihv39I1C-SZom_VJ9oj3mWqZDk',
      authDomain: 'volaninternal.firebaseapp.com',
      databaseURL: 'https://volaninternal-default-rtdb.firebaseio.com',
      projectId: 'volaninternal',
      storageBucket: 'volaninternal.appspot.com',
      messagingSenderId: '905176493683',
      appId: '1:905176493683:web:44adfc55a9323aa24c4406'
    },
    functionsUrl: 'https://southamerica-east1-volaninternal.cloudfunctions.net',
    fbId: '',
    links: links,
    android: android,
    ios: ios,
    themeColor: '#4DBA87',
    msTileColor: '#000000',
    appleMobileWebAppCapable: 'no',
    appleMobileWebAppStatusBarStyle: 'default',
    emailKey: 'admin.volan.app.br',
    region: 'southamerica-east1',
    isDevServer: true,
    isMed: true,
    // #1258: sem hosting conhecido para as linhas — o card do guard de sistema sai sem link.
    systemLineUrls: {},
    contaAzul: {
      client_id: '76lfbv63hu6g1akiisncd5ntnp',//dev
      client_secret: 'qmfq7pralb83o76397joj20is62etpp3p5mfijg1v0v6qu5skb9',//dev
    },
    apiUrl: 'https://apidev.volan.app.br',
    apiWsUrl: 'wss://apidev.volan.app.br',
    integrationsUrl: 'https://integrationsdev.volan.app.br'
  },
  'emulator': {
    configId: 'emulator',
    name: 'emulator DEVELOPER',
    maps: {
      key: 'AIzaSyAjSPrpte94NNTEnfqToUNhczN0RsVe1M4'
    },
    title: 'emulator DEV ',
    description: 'Volan emulator!',

    baseUrl: 'https://dev.volan.app.br',
    baseUrlForms: 'https://formsdev.volan.app.br',
    firebase: {
      appId: 'volandevjw',
      apiKey: 'emulator',
      projectId: 'volandevjw',
      storageBucket: 'default-bucket',
      databaseURL: 'http://localhost:47677?ns=volandevjw',
    },
    functionsUrl: 'http://localhost:47672/volandevjw/southamerica-east1',
    fbId: '',
    links: links,
    android: android,
    ios: ios,
    themeColor: '#4DBA87',
    msTileColor: '#000000',
    appleMobileWebAppCapable: 'no',
    appleMobileWebAppStatusBarStyle: 'default',
    emailKey: 'admin.volan.app.br',
    region: 'southamerica-east1',
    isDevServer: true,
    isMed: true,
    // #1258: sem hosting conhecido para as linhas — o card do guard de sistema sai sem link.
    systemLineUrls: {},
    contaAzul: {
      client_id: '76lfbv63hu6g1akiisncd5ntnp',
      client_secret: 'qmfq7pralb83o76397joj20is62etpp3p5mfijg1v0v6qu5skb9',
    },
    apiUrl: 'https://apidev.volan.app.br',
    apiWsUrl: 'wss://apidev.volan.app.br',
    integrationsUrl: 'https://integrationsdev.volan.app.br'
  }
};

if (process.env.GCLOUD_PROJECT_ON_BUILD === 'volanjwcg') {
  toExport.config = toExport.listConfig['volanjwcg'];
  // console.log('Server config start configName: ' + toExport.config.name+ ' on project: '+(process.env.GCLOUD_PROJECT_ON_BUILD||''));
}
else if (toExport.listConfig[process.env.GCLOUD_PROJECT_ON_BUILD]) {
  toExport.config = toExport.listConfig[process.env.GCLOUD_PROJECT_ON_BUILD];
  console.log('Server config start configName: ' + toExport.config.name + ' on project: ' + (process.env.GCLOUD_PROJECT_ON_BUILD || ''));
}
else {
  toExport.config = toExport.listConfig['default'];
  console.log('Server config start configName: ' + toExport.config.name + ' on project: ' + (process.env.GCLOUD_PROJECT_ON_BUILD || ''));
}

// console.log('Server config start configName: ' + toExport.config.name);
if (typeof window !== 'undefined' && window?.location?.origin?.includes('localhost')) {
  toExport.config.baseUrl = window.location.origin;
}

if (process.env.USE_LOCAL_API) {
  // GraphQL local apenas se não for explicitamente cloud
  if (process.env.USE_CLOUD_GRAPHQL !== '1') {
    toExport.config.apiUrl = 'http://localhost:4000';
    toExport.config.apiWsUrl = 'ws://localhost:4000';
  }
  toExport.config.contaAzul.client_id = '76lfbv63hu6g1akiisncd5ntnp';
  toExport.config.contaAzul.client_secret = 'qmfq7pralb83o76397joj20is62etpp3p5mfijg1v0v6qu5skb9';
}

if (process.env.USE_LOCAL_CLOUD) {
  toExport.config.functionsUrl = 'http://localhost:47672/volandevjw/southamerica-east1';
}

if (process.env.USE_LOCAL_FORMS) {
  toExport.config.baseUrlForms = 'http://localhost:8082';
}

if (process.env.USE_LOCAL_FORMS_PROD) {
  toExport.config.baseUrlForms = 'http://localhost:8092';
}

if(process.env.NODE_ENV !== 'production') {
  // toExport.config.functionsUrl = 'http://localhost:47672/volanjwcg/southamerica-east1';
}

toExport.appConfig = toExport.config;

module.exports = toExport;
